__turbopack_context__.v({
  "clientMenu": "ClientMenu-module__HCq_cW__clientMenu",
  "clientMenuContainer": "ClientMenu-module__HCq_cW__clientMenuContainer",
});
